<template>
  <div class="loop-item img-square">
    <div class="item-image">
      <a :href="item.link" target="_blank">
        <img :src="item.image" alt />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  }
};
</script>
